import {
  CognitoUserPool
} from 'amazon-cognito-identity-js'

let currentUser = null

export const getCurrentUser = () => currentUser

export const setCurrentUser = user => {
  currentUser = user
}

export const getUserPool = () => {
  const poolData = {
    UserPoolId: window.constants.COGNITO.poolId,
    ClientId: window.constants.COGNITO.frontendClient.id
  }
  return new CognitoUserPool(poolData)
}

export const getCognitoUser = () => {
  const userPool = getUserPool()

  return new Promise((resolve, reject) => {
    currentUser = userPool.getCurrentUser()

    if (currentUser) {
      currentUser.getSession(err => {
        if (err) {
          reject(err)
        } else {
          resolve(currentUser)
        }
      })
    } else {
      let err = new Error('No current user')
      err.code = 'ERR_NO_CURRENT_USER'

      reject(err)
    }
  })
}

async function delay (duration = 0) {
  await new Promise(resolve => {
    setTimeout(resolve, duration)
  })
}

export const getIdToken = (forceRedirect = true, attempt = 1, retryDelay = 100) => {
  async function getToken () {
    const user = await getCognitoUser()
    const session = user.getSignInUserSession()

    if (!session) {
      const err = new Error("Failed to get user's sign-in session")
      err.code = 'ERR_NO_SESSION'

      throw err
    }

    return session
      .getIdToken()
      .getJwtToken()
  }

  return getToken()
    .catch(err => {
      const isMissingSessionError = err?.code === 'ERR_NO_SESSION'

      if (isMissingSessionError && attempt < 5) {
        return delay(retryDelay)
          .then(() => getIdToken(forceRedirect, attempt + 1, retryDelay))
      }

      if (forceRedirect || isMissingSessionError) {
        window.location.href = '/login'

        return
      }

      throw err
    })
}
